import { arrayOf, number, shape, string } from 'prop-types'
import { useSelector } from 'react-redux'
import React from 'react'

function Price({ product, className }) {
  const quantity = useSelector((state) => state.getIn(['view', 'buybox', 'productQuantity'])) || 1

  const getBulkPrice = () => {
    const bulkPrices = product.bulkPrices
    const bulkPrice = bulkPrices
      .sort((b, a) => a.quantity.amount - b.quantity.amount)
      .find((bp) => quantity >= bp.quantity.amount)

    return bulkPrice ? bulkPrice.price.formatted : product.price.formatted
  }

  return <h3 className={className}>{product.bulkPrices ? getBulkPrice() : product.price.formatted}</h3>
}

Price.propTypes = {
  product: shape({
    price: shape({
      formatted: string.isRequired,
    }).isRequired,
    bulkPrices: arrayOf(
      shape({
        quantity: shape({
          amount: number,
        }),
        price: shape({
          formatted: string,
        }),
      }),
    ),
  }).isRequired,
  className: string,
}

export default Price
